import { Week39LineStaffCell } from "./Week39LineStaffCell";
import { formatDay } from "./week39-view";
import type { PackagingReport } from "./week39-report";
import { reportStaffingEntries } from "./week39-report";
import type { LineStaff, PlannedLineStaff } from "./useWeek39LineStaff";

export function Week39ReportStaffing({ report, lineStaff, plannedLineStaff, canEdit, loaded, unavailable, onSave }: {
  report: PackagingReport; lineStaff: LineStaff[]; plannedLineStaff: PlannedLineStaff[];
  canEdit: boolean; loaded: boolean; unavailable: boolean;
  onSave: (input: { date: string; lineName: string; count: number; expectedVersion: number }) => Promise<LineStaff>;
}) {
  const entries = reportStaffingEntries(report);
  if (!entries.length) return <p className="pack39-report-caption">Seçili plan satırlarında gün ve hat eşleşmesi yok.</p>;
  return <><p className="pack39-report-caption">Planlanan kişi haftalık kadro planından, çalışan kişi kullanıcı kaydından gelir. Girilmeyen sayı sıfır sayılmaz.</p>
    <div className="pack39-report-table-scroll" role="region" tabIndex={0} aria-label="Günlük hat kişi sayıları">
      <table className="pack39-report-table pack39-report-staffing"><caption className="pack39-sr-only">Gün ve hat bazında planlanan ve çalışan kişi sayıları</caption>
        <thead><tr><th scope="col">Gün</th><th scope="col">Hat</th><th scope="col">Planlanan kişi</th><th scope="col">Çalışan kişi</th></tr></thead>
        <tbody>{entries.map(({ date, lineName }) => {
          const planned = plannedLineStaff.find((item) => item.date === date && item.lineName === lineName);
          const actual = lineStaff.find((item) => item.date === date && item.lineName === lineName);
          return <tr key={`${date}|${lineName}`}><th scope="row">{formatDay(date, { day: "numeric", month: "short", weekday: "short" })}</th><td>{lineName}</td>
            <td>{!loaded ? "Yükleniyor" : unavailable ? "Veri alınamadı" : planned?.count === null ? "Ortak ekip" : planned ? `${planned.count} kişi` : "Girilmedi"}
              {planned?.note ? <small className="pack39-report-subtext">{planned.note}</small> : null}</td>
            <Week39LineStaffCell date={date} lineName={lineName} rowSpan={1} record={actual} canEdit={canEdit && lineName !== "Hat eşleşmedi"} loaded={loaded} unavailable={unavailable} save={onSave} idSuffix="report" />
          </tr>;
        })}</tbody>
      </table>
    </div></>;
}
